import React, { useContext } from "react";
import styles from "./css/aboutCard.module.css";
import { IdiomaContext } from './context/IdiomaContext';
import { traducciones } from '../data/aboutData';
import { useInView } from 'react-intersection-observer';
import { NavLink } from 'react-router-dom';

function AboutCard({ id }) {
  const { idioma } = useContext(IdiomaContext);
  const traduccion = traducciones[id][idioma];
  const { ref, inView } = useInView({ threshold: 0.1 });

  console.log(traduccion);

  if (!traduccion) {
    return null;
  }

  return (
    <div className={styles.container}>
        {/* <div className={styles.layout__portfolio}>
            {(id === 1 || window.innerWidth < 768) && <h1 className={styles.titlePortfolio}>{traduccion.titlePortfolio}</h1>}
        </div> */}
        <div className={styles.container__layout}>
        
            <div className={`${styles.layout} ${inView ? styles.fadeIn : styles.fadeOut}`} ref={ref}>
                {/* <button className={styles.closeButton} onClick={() => window.history.back()}>X</button> */}
                <div className={styles.About}>
                    <h1 className={styles.layout__title}>{traduccion.title}</h1>
                    <div className={styles.profileAbout}>
                        <div className={styles.projectData}>
                            <img src={traduccion.imageUrl} alt="Project" className={styles.image} />
                            <div className={styles.textDescription}>{traduccion.description}</div>
                            <div className={styles.textDescription}>{traduccion.description2}</div>
                            <div className={styles.textDescription}>{traduccion.description3}</div>
                            <hr className={styles.hrBar}/>
                            <div className={styles.textBox}>
                                <div className={styles.textDescription}>{traduccion.description4}</div>
                                <img src={traduccion.imageUrl2} alt="Project" className={styles.image} />
                            </div>
                            
                            <div className={styles.textProject}>{traduccion.textTecnology}</div>
                            {/* <div className={styles.textProjectN}>{traduccion.tecnology}</div> */}
                            
                            <div className={styles.botton_Url}>
                                <NavLink to={traduccion.url} className={styles.text_Url}>{traduccion.textUrl}</NavLink>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default AboutCard;
